module.exports = __webpack_public_path__ + "img/kefu.f2c034ac.png";